import { Route } from "@angular/router";
import { SaldoPage } from "./saldo.page";

export const SaldoRouter: Route[] = [
  { path: 'saldo', component: SaldoPage }
];
